import * as React from "react";
import { useIntl } from "react-intl";
import ReactSelect from "react-select";

import { ReactSelectOptions } from "../../../../../types";
import { SelectContainer } from "../ChoiceFilter.sc";
import { selectStyles } from "../ReactSelectStyle";

interface ISingleChoiceFilter<T> {
    value?: T;
    options: ReactSelectOptions<T>[];
    onChange?: (value: T | null) => void;
    placeholder?: string;
    isSearchable?: boolean;
    isClearable?: boolean;
    isDisabled?: boolean;
    variant?: "default" | "dark" | "sort";
    isSmall?: boolean;
    inputId?: string;
    labelId?: string;
}

const SingleChoiceFilter = <T extends any>({
    value,
    options,
    onChange,
    placeholder,
    variant = "default",
    isSearchable = false,
    isClearable = false,
    isDisabled = false,
    isSmall,
    inputId,
    labelId,
}: ISingleChoiceFilter<T>) => {
    const intl = useIntl();

    //This is because the lack of support of SSR in react-select
    const [currentValue, setCurrentValue] = React.useState<ReactSelectOptions<T> | undefined>(undefined);

    React.useEffect(() => {
        setCurrentValue(valueForOptions(options, value));
    }, [value, options]);

    const handleSelectChange = (option?: ReactSelectOptions<T>) => {
        if (onChange) {
            onChange(option?.value ?? null);
        }
    };

    return (
        <SelectContainer>
            <ReactSelect
                value={currentValue ?? null}
                styles={selectStyles[variant]}
                options={options}
                onChange={handleSelectChange}
                placeholder={placeholder}
                isSearchable={isSearchable}
                isClearable={isClearable}
                isDisabled={isDisabled}
                noOptionsMessage={() =>
                    intl.formatMessage({
                        id: "leasme.filter.noOption",
                        defaultMessage: "Keine Optionen",
                    })
                }
                isSmall={isSmall}
                inputId={inputId}
                aria-labelledby={labelId}
            />
        </SelectContainer>
    );
};

export default SingleChoiceFilter;

function valueForOptions<T>(options: ReactSelectOptions<T>[], value?: T) {
    return options.find((option) => JSON.stringify(option.value) === JSON.stringify(value));
}
